import axios from "axios";

const BASE_URL = process.env.REACT_APP_SPORTYBOOK_BASE_URL;

class SportyBookApi {
  _getScheduleEventsPage(gamePk, limit, page) {
    return axios
      .get(
        `${BASE_URL}/api/v1/games/${gamePk}/events?type=SCHEDULE_EVENT&limit=${limit}&page=${page}`
      )
      .then(r => r.data);
  }

  async getScheduleEvents(gamePk, limit = 50) {
    const firstPage = await this._getScheduleEventsPage(gamePk, limit, 0);
    const events = [...(firstPage.data || [])];
    const total = firstPage.total;
    const pageCount = Math.ceil(total / limit);

    for (let page = 1; page < pageCount && events.length < total; page += 1) {
      const nextPage = await this._getScheduleEventsPage(gamePk, limit, page);
      events.push(...(nextPage.data || []));
    }

    return { data: events, total };
  }

  getPlayEvents(gamePk, playId, spanId, eventType, limit = 10, page = 0) {
    let url = `${BASE_URL}/api/v1/games/${gamePk}/plays/${playId}/events?limit=${limit}&page=${page}`;
    if (spanId) {
      url = `${url}&spanId=${spanId}`;
    }
    if (eventType) {
      url = `${url}&type=${eventType}`;
    }
    return axios.get(url).then(r => r.data);
  }

  getPlayDocuments(gamePk, playId) {
    return axios
      .get(`${BASE_URL}/api/v1/games/${gamePk}/plays/${playId}/documents`)
      .then(r => r.data);
  }
}

SportyBookApi.BASE_URL = BASE_URL;

export default SportyBookApi;
